import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import { OptionPointsContainer, OptionPointsText } from '../../../components/score-toggle/score-toggle-styles';
import { MedicalScoreParam } from '../../../model/medical-score/medical-score-param';
import { MedicalScoreParamOption } from '../../../model/medical-score/medical-score-param-option';
import { setNumberSign } from '../../../shared/util/utils';
import { useMedicalScoreContext } from '../medical-score.provider';
import { OptionLabel, pickerStyles } from './medical-score-params-styles';
import MedicalScoreParamType from '../../../model/enums/medical-score-param-type';

interface Props {
    parameterInfo: MedicalScoreParam;
    isMulti: boolean;
}

const MedicalScorePickerParam = (props: Props) => {
    const { parameterInfo, isMulti } = props;
    const options = _.sortBy(parameterInfo?.options, 'position').map(it => {
        return { ...it, value: it.id };
    });
    const { paramValues, setParamValues } = useMedicalScoreContext();

    const handleSelectOption = (item: MedicalScoreParamOption | MedicalScoreParamOption[]) => {
        const newValues = { ...paramValues };
        if (parameterInfo.inputType === MedicalScoreParamType.MULTI_ANSWER_SELECT) {
            newValues[parameterInfo.code!]!.answers = item;
        } else {
            newValues[parameterInfo.code!] = item;
        }
        setParamValues(newValues);
    };

    const formatOptionLabel = ({ presentationName, points, observation }) => (
        <div style={{ display: 'flex', minWidth: '200px' }} key={presentationName}>
            <OptionPointsContainer selected>
                <OptionPointsText selected>{points != null ? setNumberSign(points) : 0}</OptionPointsText>
            </OptionPointsContainer>

            <OptionLabel>
                {presentationName}
                {observation && <OptionLabel style={{ fontWeight: 600 }}>{` (${observation})`}</OptionLabel>}
            </OptionLabel>
        </div>
    );

    return (
        <Select
            isSearchable={false}
            styles={pickerStyles}
            isMulti={isMulti}
            options={options}
            isClearable={false}
            onChange={e => handleSelectOption(e)}
            placeholder={'Clique para selecionar...'}
            formatOptionLabel={data => formatOptionLabel(data)}
        />
    );
};

export default MedicalScorePickerParam;
